import { useTranslation } from "react-i18next";
import PageHeader from "../../../components/Common/PageHeader";
import TableFilterDynamique, { FilterField } from "components/Common/TableFilter/TableFilterDynamique";
import { all_routes } from "router/all_routes";
import { useEffect, useMemo, useState } from "react";
import usePayroll from "../hooks/usePayroll";
import MyPayrollTable from "../components/MyPayrollTable";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import CustomAlert from "components/Common/ui/CustomAlert";

const MyPayrollPage = () => {
    const { t } = useTranslation();
    const user = useSelector((state: RootState) => state.authSlice.user);
    const hasStaff = useMemo(() => {
        return user?.hasStaff;
    }, [user]);
    const {
        payrolls,
        loading,
        fetchMyPayrolls,
        handleUpdateStatus,
        pagination,
        statusOptions,
    } = usePayroll();

    const breadcrumbItems = [
        { label: "dashboard", path: all_routes.dashboard },
        { label: "payroll.my_payrolls", active: true },
    ];

    const [filters, setFilters] = useState<{ [key: string]: string | number | null }>({});

    useEffect(() => {
        if (!hasStaff) return;
        fetchMyPayrolls({ page: 1, limit: 10 });
    }, [fetchMyPayrolls]);

    const filterFields: FilterField[] = useMemo(
        () => [
            {
                key: "status",
                label: t("payroll.status"),
                type: "select",
                options: statusOptions
            }
        ],
        [t]
    );

    const handleFilter = (newFilters: { [key: string]: string | number | null }) => {
        setFilters(newFilters);
        fetchMyPayrolls({ ...newFilters, page: 1 });
    };



    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <PageHeader title={t("payroll.my_payrolls")} breadcrumbItems={breadcrumbItems} />
                {hasStaff ? (
                    <>
                        <div className="d-flex mb-3 justify-content-end gap-2">
                            <TableFilterDynamique
                                fields={filterFields}
                                filters={filters}
                                onApply={(newFilters) => handleFilter(newFilters)}
                                onReset={() => handleFilter({ page: 1, limit: 10 })}
                            />
                        </div>

                        <MyPayrollTable
                            dataSource={payrolls ?? []}
                            loading={loading}
                            dataPaginate={{
                                current: pagination?.page,
                                pageSize: pagination?.limit,
                                total: pagination?.total,
                            }}
                            onChange={(pg) => {
                                fetchMyPayrolls({
                                    ...filters,
                                    page: pg?.current!,
                                    limit: pg?.pageSize!,
                                });
                            }}
                        />
                    </>
                ) : (
                    <CustomAlert
                        message={t("alert.no_staff_alert.message")}
                        description={t("alert.no_staff_alert.description")}
                        type="info"
                        showIcon
                    />
                )}


            </div>
        </div>
    );
};

export default MyPayrollPage;